export default {"src":"https://s.sylndr.com/c-3732c05/_next/static/media/tagIcon.435edb09.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};